import { createFileRoute, redirect } from '@tanstack/react-router';

/** Keep existing links working while all campaign work stays on one page. */
export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/marketing/advertising/new'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/l/$locationId/marketing/advertising',
      params: { locationId: params.locationId },
      search: { create: true },
      replace: true,
    });
  },
});
